var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRequestsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10547 17.3828H14.2773C16.3086 17.3828 17.3828 16.3184 17.3828 14.3066V3.08594C17.3828 1.07422 16.3086 0 14.2773 0H3.10547C1.08398 0 0 1.06445 0 3.08594V14.3066C0 16.3184 1.08398 17.3828 3.10547 17.3828ZM8.7207 13.2715C8.125 13.2715 7.76367 12.8418 7.76367 12.2461V9.64844H5.01953C4.41406 9.64844 3.98438 9.28711 3.98438 8.70117C3.98438 8.10547 4.4043 7.73438 5.01953 7.73438H7.76367V5C7.76367 4.4043 8.125 3.97461 8.7207 3.97461C9.29688 3.97461 9.6875 4.39453 9.6875 5V7.73438H12.4414C13.0566 7.73438 13.4668 8.10547 13.4668 8.70117C13.4668 9.28711 13.0371 9.64844 12.4414 9.64844H9.6875V12.2461C9.6875 12.8613 9.29688 13.2715 8.7207 13.2715Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestsIcon);
export default __webpack_public_path__ + "static/media/requests-icon.b657c334112fd89d05ab74500291d5a8.svg";
export { ForwardRef as ReactComponent };